(function () {
  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function sanitizeNameValue(value) {
    return (value || '').replace(/[^A-Za-z]/g, '');
  }

  function normalizeIndoPhone(value) {
  var v = (value || '').trim();

  // remove non-digits
  v = v.replace(/\D/g, '');

  // remove leading 62
  if (v.startsWith('62')) {
    v = v.slice(2);
  }

  // remove leading 0
  if (v.startsWith('0')) {
    v = v.slice(1);
  }

  // limit to max 12 digits (Indonesia mobile: 10-12 digits without country code)
  if (v.length > 12) {
    v = v.slice(0, 12);
  }

  return v;
}

  function isValidIndoPhone(value) {
  var v = (value || '').trim().replace(/\D/g, '');
  // Indonesia mobile numbers: 10-12 digits (without country code)
  return v.length >= 10 && v.length <= 12;
}


  function setupRegisterFormValidation(form) {
    if (!form) return;
    var dob = form.querySelector('#RegisterForm-DateOfBirth, #RegisterInline-DateOfBirth');

    var firstName = qs(form, 'input[name="customer[first_name]"]');
    var lastName = qs(form, 'input[name="customer[last_name]"]');
    var phone = qs(form, '#RegisterForm-Phone, #RegisterInline-Phone') || qs(form, 'input[name="customer[phone]"], input[name="customer[note][phone]"]');
    var email = qs(form, 'input[name="customer[email]"]');
    var password = qs(form, 'input[name="customer[password]"]');
    var confirmPassword = qs(form, '#RegisterForm-password-confirm, #RegisterInline-password-confirm');
    var gender = qs(form, '#RegisterForm-Gender');
    var consent = qs(form, 'input[name="customer[note][consent]"]');
    var submitBtn = qs(form, 'button[type="submit"], button:not([type]), input[type="submit"]');
    var emailCheckInProgress = false;
    var emailExists = false;

    function setSubmitEnabled(enabled) {
      if (!submitBtn) return;
      submitBtn.disabled = !enabled;
      submitBtn.setAttribute('aria-disabled', String(!enabled));
    }

    function isRequiredFilled(el) {
      if (!el) return true;
      if (el.disabled) return true;
      if (!el.required) return true;

      var type = (el.getAttribute('type') || '').toLowerCase();
      if (type === 'checkbox' || type === 'radio') return !!el.checked;
      return (el.value || '').trim() !== '';
    }

    function sanitizeNames() {
      if (firstName) firstName.value = sanitizeNameValue(firstName.value);
      if (lastName) lastName.value = sanitizeNameValue(lastName.value);
    }

    function sanitizeAndValidatePhone() {
  if (!phone) return true;

  const normalized = normalizeIndoPhone(phone.value);

  if (phone.value !== normalized) {
    phone.value = normalized;
  }

if (!phone.value) return false;

  if (!isValidIndoPhone(phone.value)) {
    phone.setCustomValidity('Enter a valid Indonesian mobile number (10–12 digits)');
    phone.reportValidity();
    return false;
  }

  phone.setCustomValidity('');
  return true;
}


   function validatePasswordMatch() {
  if (!password || !confirmPassword) return true;

  const p = (password.value || '').trim();
  const c = (confirmPassword.value || '').trim();

  if (!p || !c) {
    confirmPassword.setCustomValidity('Please confirm your password');
    return false;
  }

  if (p !== c) {
    confirmPassword.setCustomValidity('Passwords do not match');
    confirmPassword.reportValidity();
    return false;
  }

  confirmPassword.setCustomValidity('');
  return true;
}

    function validateConsent() {
      if (!consent) return true;
      if (consent.required && !consent.checked) {
        consent.setCustomValidity('Please accept to continue');
        return false;
      }
      consent.setCustomValidity('');
      return true;
    }

    function isValidEmailFormat(emailValue) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(emailValue);
    }

    async function checkEmailExists(emailValue) {
      // Disable pre-check - let Shopify handle email validation on form submit
      // This prevents false positives that block new user registration
      return false;
    }

   async function validateEmail() {
  if (!email) return true;

  const emailValue = (email.value || '').trim();

  if (!emailValue) {
    email.setCustomValidity('Email is required');
    email.reportValidity();
    return false;
  }

  if (!isValidEmailFormat(emailValue)) {
    email.setCustomValidity('Please enter a valid email address');
    email.reportValidity();
    return false;
  }

  email.setCustomValidity('');
  return true;
}

   function isValidDOB() {
  if (!dob) return true;

if (!dob.value) {
  dob.setCustomValidity('');
  return false;
}

  const selected = new Date(dob.value);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  if (selected >= today) {
    dob.setCustomValidity('Date of birth must be earlier than today');
    dob.reportValidity();
    return false;
  }

  let age = today.getFullYear() - selected.getFullYear();
  const m = today.getMonth() - selected.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < selected.getDate())) age--;

  if (age < 18) {
    dob.setCustomValidity('You must be at least 18 years old');
    dob.reportValidity();
    return false;
  }

  dob.setCustomValidity('');
  return true;
}

function validateNames() {
  let valid = true;

  if (firstName) {
    firstName.value = sanitizeNameValue(firstName.value);

    if (!firstName.value.trim()) {
      firstName.setCustomValidity('First name is required');
      valid = false;
    } else {
      firstName.setCustomValidity('');
    }
  }

  if (lastName) {
    lastName.value = sanitizeNameValue(lastName.value);

    if (!lastName.value.trim()) {
      lastName.setCustomValidity('Last name is required');
      valid = false;
    } else {
      lastName.setCustomValidity('');
    }
  }

  return valid;
}

function validateGender() {
  if (!gender) return true;

  if (!gender.value || gender.value === '') {
    gender.setCustomValidity('Please select your gender');
    return false;
  }

  gender.setCustomValidity('');
  return true;
}

    function updateSubmitState() {
      sanitizeNames();
      var nameOk = validateNames();
      var genderOk = validateGender();
      var phoneOk = sanitizeAndValidatePhone();
      var passOk = validatePasswordMatch();
      var consentOk = validateConsent();

      var requiredEls = qsa(form, 'input[required], select[required], textarea[required]');
      var allFilled = requiredEls.every(isRequiredFilled);

      // setSubmitEnabled(allFilled && phoneOk && passOk && consentOk);
      var dobOk = dob && dob.value && isValidDOB();
      var emailOk = !emailExists && !emailCheckInProgress;

     setSubmitEnabled(allFilled && nameOk && genderOk && phoneOk && passOk && consentOk && dobOk);
    }

    // initial state
    setSubmitEnabled(false);
    updateSubmitState();
    setTimeout(updateSubmitState, 0);

    // Bind events
    qsa(form, 'input, select, textarea').forEach(function (el) {
      el.addEventListener('input', updateSubmitState);
      el.addEventListener('change', updateSubmitState);
    });

    if (password) {
      password.addEventListener('input', function () {
        validatePasswordMatch();
      });
    }

    if (confirmPassword) {
      confirmPassword.addEventListener('input', function () {
        validatePasswordMatch();
      });
    }

    function validateNames() {
  let valid = true;

  if (firstName) {
    firstName.value = sanitizeNameValue(firstName.value);

    if (!firstName.value.trim()) {
      firstName.setCustomValidity('First name is required');
      valid = false;
    } else {
      firstName.setCustomValidity('');
    }
  }

  if (lastName) {
    lastName.value = sanitizeNameValue(lastName.value);

    if (!lastName.value.trim()) {
      lastName.setCustomValidity('Last name is required');
      valid = false;
    } else {
      lastName.setCustomValidity('');
    }
  }

  return valid;
}
    if (dob) {
      dob.addEventListener('change', function () {
        isValidDOB();
        dob.reportValidity();
      });
      dob.addEventListener('blur', function () {
        if (dob.value) {
          isValidDOB();
          dob.reportValidity();
        }
      });
    }

    if (email) {
      var emailDebounceTimer;
      email.addEventListener('blur', function () {
        clearTimeout(emailDebounceTimer);
        emailDebounceTimer = setTimeout(function() {
          validateEmail().then(updateSubmitState);
        }, 300);
      });
      email.addEventListener('input', function () {
        emailExists = false;
        email.setCustomValidity('');
      });
    }

 form.addEventListener('submit', async function (e) {
  e.preventDefault();

  sanitizeNames();

  const nameOk = validateNames();
  const genderOk = validateGender();
  const emailOk = email ? await validateEmail() : true;
  const phoneOk = sanitizeAndValidatePhone();
  const dobOk = isValidDOB();
  const passOk = validatePasswordMatch();
  const consentOk = validateConsent();

  const nativeValid = form.checkValidity();

  if (!nativeValid || !nameOk || !genderOk || !emailOk || !phoneOk || !dobOk || !passOk || !consentOk) {
    form.reportValidity();
    return;
  }

  if (phone && phone.value) {
    phone.value = '+62' + phone.value;
  }

  form.submit();
});
  }

  function init() {
    // standalone register page
    var registerRoot = document.querySelector('.customer.register');
    if (registerRoot) {
      setupRegisterFormValidation(qs(registerRoot, 'form'));
    }

    // inline register on login page
    var inlineRegisterCol = document.querySelector('.customer.login .customer__column--register');
    if (inlineRegisterCol) {
      setupRegisterFormValidation(qs(inlineRegisterCol, 'form'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('click', function (e) {
  const toggle = e.target.closest('.password-toggle');
  if (!toggle) return;

  togglePassword(toggle);
});

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;

  const toggle = e.target.closest('.password-toggle');
  if (!toggle) return;

  e.preventDefault();
  togglePassword(toggle);
});

function togglePassword(toggle) {
  const input = toggle.previousElementSibling;
  const openEye = toggle.querySelector('.eye-open');
  const closedEye = toggle.querySelector('.eye-closed');

  const show = input.type === 'password';

  input.type = show ? 'text' : 'password';
  openEye.style.display = show ? 'block' : 'none';
  closedEye.style.display = show ? 'none' : 'block';

  toggle.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
}

 document.querySelectorAll('input, select').forEach(el => {
  el.addEventListener('input', () => {
    sessionStorage.setItem(el.name, el.value);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input, select').forEach(el => {
    const saved = sessionStorage.getItem(el.name);
    if (saved && !el.value) el.value = saved;
  });
});

if (!document.querySelector('.form__message')) {
  sessionStorage.clear();
}
})();
